import React, {useEffect, useState, useRef} from 'react';
import { useForm } from 'react-hook-form';
import exclamationImg from '../assets/images/exclamationErrorIcon.svg'
import {Check } from '@material-ui/icons';
import Loading from './LoadingComponent'
import { withRouter } from "react-router";
import { connect } from 'react-redux';
import A12Y_CONST from '../common/a12yConst'
import LoaderFullScreen from './LoaderFullScreenComponent'
import logoImg from '../assets/images/aboneSrcImage.png'

function getWindowDimensions() {
    const { innerWidth: width, innerHeight: height } = window;
    return {
        width,
        height
    };
}

function SignUpFormAbonelawComponent (props) {
    const signUpboxRef = useRef(null)
    const [passwordShown, setPasswordShown] = useState(false);
    const [passwordConditionBox, setPasswordConditionBox] = useState(false);
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [userName, setUserName] = useState('');
    const [password, setPassword] = useState('');
    const [error, setErrors] = useState(false);
    const [isUserInvite, setIsUserInvite] = useState(false);
    const [passwordErrorHide, setaPsswordErrorHide] = useState(false);
    const [loading, setLoading] = useState(false);
    const [isBtnDisabled, setIsBtnDisabled] = useState(false);
    const [loaderFullScreenVisible, setLoaderFullScreenVisible] = useState(false);

    const [invitedByName, setInvitedByName] = useState(false);
    const [invitedfor, setInvitedfor] = useState(false);
    /* eslint-disable no-unused-vars */
    const [firstNameFocus, setFirstNameFocus] = useState(false)
    const [passwordSuccessMessage, setPasswordSuccessMessage] = useState(false);
    const [isBoxHeightHeigher, setiIsBoxHeightHeigher] = useState(false);
    const [signUpBoxHeight, setSignUpBoxHeight] = useState(0);
    const [windowDimensions, setWindowDimensions] = useState(getWindowDimensions());
    const [passwordCondition, setPasswordCondition] = useState([
        {
            type:'lowercaseCharacter',
            name: 'One lowercase character',
            status: false
        },
        {
            type:'minimumCharacters',
            name: '8 characters minimum',
            status: false
        },
        {
            type:'uppercaseCharacter',
            name: 'One uppercase character',
            status: false
        },
        {
            type:'numberOnly',
            name: 'Should be one number',
            status: false
        },
        {
             type:'specialCharacter',
             name: 'One special character ! = @ # $ % ^ & *',
             status: false
        }
    ])
    /* eslint-disable no-unused-vars */

        const {register,handleSubmit, setError, setFocus , setValue ,formState:{ errors},} = useForm({mode:"all"});

    const onSubmit = async (user) => {
        setIsBtnDisabled(true);
        let obj = {
            "first_name" :user.firstName,
            "last_name" : user.lastName,
            "email" : user.username,
            "password" : user.password
        }
        await props.onSubmit(obj)
        await setIsBtnDisabled(false)
    };

    useEffect(  () => {
       async function dimensionCalculate() {
           let screenHeight = windowDimensions.height;
           let boxHeight = signUpboxRef.current.clientHeight + 110
           await setSignUpBoxHeight(signUpboxRef.current.clientHeight + 110)
           if(windowDimensions.width >= 951) {
               if (boxHeight > screenHeight) {
                   setiIsBoxHeightHeigher(true);
               } else {
                   setiIsBoxHeightHeigher(false);
               }
           }
       }
        dimensionCalculate()
    })

    useEffect(()=>{
        if(userName){
            setValue('username',userName)
        }if(password){
            setValue('password',password)
            setPassword(password)
            setError("password", {
                type: "manual",
                message: "",
            });
        }
    },[userName,password]) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        setFocus("firstName");
    }, [setFocus])

    useEffect( () => {
        setLoading(props.loading)
        setErrors(props.error)
        setLoaderFullScreenVisible(props.loaderFullScreen)
    }, [props.loading,props.error,props.loaderFullScreen])

    useEffect(() => {
        window.history.pushState(null, document.title, window.location.href);
        window.addEventListener('popstate', function (event){
            window.history.pushState(null, document.title,  window.location.href);
        });
        setLoaderFullScreenVisible(false)
    },[])
     useEffect(() => {
         if(props.inviteUserInfo && Object.keys(props.inviteUserInfo).length > 0){
             setIsUserInvite(true);
             setInviteUserInfo()
         }
         setLoaderFullScreenVisible(false)
     },[props.inviteUserInfo]) // eslint-disable-line react-hooks/exhaustive-deps


    const setInviteUserInfo = () => {
        setValue("firstName",props.inviteUserInfo.userFirst_Name)
        setValue("lastName",props.inviteUserInfo.userLast_Name)
        setValue("username",props.inviteUserInfo.userEmail)
        setFirstName(props.inviteUserInfo.userFirst_Name);
        setLastName(props.inviteUserInfo.userLast_Name);
        setUserName(props.inviteUserInfo.userEmail);
        setInvitedByName(props.inviteUserInfo.userByName)
        setInvitedfor(props.inviteUserInfo.invited_for)
    }

    const togglePasswordVisiblity = () => {
        setPasswordShown(passwordShown ? false : true);
    };
    const goToLoginScreen = () => {
            props.history.push('/LoginForm');
    }
    const handleChangePassword = (event) => {
        if(event.target.value === " "){
            return
        }else{
        let count = 0;
        if(event.target.value.length > 0){
            setPasswordConditionBox(true)
        }
        else{
            setPasswordConditionBox(false)
        }
        let lowercaseCharacter = /[a-z]/g;
        if(event.target.value.match(lowercaseCharacter)) {
            validatePassword('lowercaseCharacter', true)
            count++
        } else {
            validatePassword('lowercaseCharacter', false)
        }
        let uppercaseCharacter = /[A-Z]/g;
        if(event.target.value.match(uppercaseCharacter)) {
            validatePassword('uppercaseCharacter', true)
            count++
        } else {
            validatePassword('uppercaseCharacter', false)
        }
        let numberOnly = /[0-9]/g;
        if(event.target.value.match(numberOnly)) {
            validatePassword('numberOnly', true)
            count++
        } else {
            validatePassword('numberOnly', false)
        }
            //eslint-disable-next-line
        let specialCharacter = /[!=@#$%^&*]/;
        if(event.target.value.match(specialCharacter)) {
            validatePassword('specialCharacter', true)
            count++
        } else {
            validatePassword('specialCharacter', false)
        }
        if(event.target.value.length >= 8) {
            validatePassword('minimumCharacters', true)
            count++
        } else {
            validatePassword('minimumCharacters', false)
        }
            if(count === passwordCondition.length) {
                setPasswordSuccessMessage(true);
                setaPsswordErrorHide(false)
            }else{
                setPasswordSuccessMessage(false);
                setaPsswordErrorHide(true)
            }
        setPassword(event.target.value);
        }
    };

    const validatePassword = (type, status) => {
        passwordCondition.forEach((item, index) => {
            if(item.type === type){
                item.status = status
            }
        })

    }
    const goToSignInScreen = () => {
        props.history.push(A12Y_CONST.ROUTE.LOGIN);
    }

    const handleChangeFirstName = (value) => {
        if(setFirstNameFocus && value.length > 0){
            setError("firstName", {
                type: "manual",
                message: "",
            });
        }

        if(value.trim().length === 0 ){
            setFirstName('');
        }else{
            //eslint-disable-next-line
            if(/^[a-z\d\_\s]+$/i.test(value)){
                setFirstName(value);
            }
        }
    }
    const handleChangeLastName = (value) => {
        if(value.trim().length === 0 ){
            setLastName('');
        }else{
            //eslint-disable-next-line
            if(/^[a-z\d\_\s]+$/i.test(value)){
                setLastName(value);
            }
        }
    }
    const handleUserName = (value) => {
        let val = value.toLowerCase();
        if(val.length === 1 && val === " "){
            return
        }else{
            setUserName(val);
        }
    }

    const handeBlankSpace = (e) => {
        if(e.key === " "){
            e.preventDefault();
        }
    }

    useEffect(() => {
        const search = window.location.search;
        const params = new URLSearchParams(search);
        const fname = params.get('fname');
        const lname = params.get('lname');
        const email = params.get('email');
        if(fname){
            setValue("firstName",fname)
            setFirstName(fname)
        }
        if(lname){
            setValue("lastName",lname)
            setLastName(lname)
        }
        if(email){
            setValue("username",email)
            setUserName(email)
        }

    },[]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleGoogleLogin = () => {
        window.location.href=props.url;
    }
    useEffect(() => {
        if(props.userEmail){
            setValue("username",props.userEmail)
            setUserName(props.userEmail);

        }
    },[props.userEmail, setValue])
    return (
        <div>
            {loading ?
                <div className="transparentLayer"></div>
                :
                null
            }
            { loaderFullScreenVisible ?
                <LoaderFullScreen/>
                :
                null
            }

                <div ref={signUpboxRef} className={isUserInvite ? 'signColCenter signColCenterInviteUser fullWidth abonelawMain' : 'signColCenter paddingLeftPaddingRight35 fullWidth abonelawMain'}>
                    {/* <h3 className={isUserInvite? 'titleWelcomeToAccount marginNone texAlingCener' : 'marginNone titleWelcomeToAccount'}>{props.signUpText.title === A12Y_CONST.LABEL.ITS_FREE_ACCOUNT ? A12Y_CONST.LABEL.TELL_US_LITTLE_ABOUT_YOU : A12Y_CONST.LABEL.WELCOME_TO_ADVOCORD}</h3> */}
                    <div className='trustedPartner'>{A12Y_CONST.LABEL.SPONSORED_BY}</div>
                    <div className='signUpLogoCol'><img className='animationall cursorPointer' id='MarketingSiteabonelaw' src={logoImg} alt='logo1'/></div>
                    {!isUserInvite? <div className='letUsCreate'>{A12Y_CONST.LABEL.ONCE_YOU_CREATE_YOUR_FREE} <strong className='fontbold'> {A12Y_CONST.LABEL.FREE}</strong> {A12Y_CONST.LABEL.ACCOUNT_ENTER_THE}</div>:null}
                    {error ?
                    <div className="positionRelative fullWidth">
                        <div className="errorMessageWithBackground positionAbsoute">
                            <div className="exclamationErrorIcon"><img alt='' src={exclamationImg}/></div>
                            <div className='errorTextContent'>{props.errorMessage}</div>
                        </div>
                    </div>
                        :
                       <> {isUserInvite ?
                            <div className="positionRelative fullWidth">
                                <div className="positionAbsoute">
                                    <div className='infoBoxInviteUser'>
                                <span className='infoIconInviteUser'>
                                    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M20 12C15.5817 12 12 15.582 12 20C12 24.418 15.5817 28 20 28C24.4183 28 28 24.418 28 20C28 15.582 24.4183 12 20 12ZM10 20C10 14.477 14.4771 10 20 10C25.5228 10 30 14.477 30 20C30 25.523 25.5228 30 20 30C14.4771 30 10 25.523 10 20Z" fill="#71767A"/>
                                        <path d="M20 18C20.5523 18 21 18.448 21 19V25C21 25.552 20.5523 26 20 26C19.4477 26 19 25.552 19 25V19C19 18.448 19.4477 18 20 18Z" fill="#71767A"/>
                                        <path d="M21.5 15.5C21.5 16.328 20.8284 17 20 17C19.1716 17 18.5 16.328 18.5 15.5C18.5 14.672 19.1716 14 20 14C20.8284 14 21.5 14.672 21.5 15.5Z" fill="#71767A"/>
                                    </svg>
                                </span>
                                        <span className='infoTextInviteUser'>{A12Y_CONST.TEXT.YOU_HAVE_BEEN} {invitedByName?invitedByName:''} {A12Y_CONST.TEXT.TO_CREATE_AN_ACCOUNT} {invitedfor?invitedfor:null}'s {A12Y_CONST.TEXT.ACCOUNTABILITY_INFORMATION}</span>
                                    </div>
                                </div>
                            </div>
                            :
                            null
                        }
                        </>
                    }

                    <form autoComplete="off" className={isUserInvite ? 'marginTop70 signUpFlow fullWidth':'marginTop60 fullWidth signUpFlow'}>
                        <div className='fullWidth  firstLastNameSpaceSignUp'>
                            <div className='width50 paddingRight1 signUpFirstName'>
                                <label>{A12Y_CONST.LABEL.FIRST_NAME}</label>
                                <input
                                    {...register('firstName', { required: A12Y_CONST.ERROR_MESSAGE.SIGNUP_FIRST_NAME_REQUIRED , pattern:{
                                        value:/^.{1,}$/,
                                        //value:/^[^\s]+(\s+[^\s]+)*.{3,}$/,
                                        message:A12Y_CONST.ERROR_MESSAGE.SIGNUP_FIRST_NAME_INVALID
                                    }})}
                                    placeholder='First Name'
                                    className={errors.firstName ? 'inputColum errorInputBorderRed': 'inputColum'}
                                    type='text'
                                    pattern=''
                                    id='userFirstNameAbonelaw'
                                     onChange={(e) => handleChangeFirstName(e.target.value)}
                                     value={firstName}
                                    autoComplete="none"
                                    onFocus={()=>{
                                        setError("firstName", {
                                            type: "manual",
                                            message: "",
                                        });
                                       setFirstNameFocus(true)
                                    }}
                                />
                               <div className='errorRelativeRow'> {errors.firstName && <p className='errorMessage'>{errors.firstName.message}</p>}</div>
                            </div>
                            <div className='width50 paddingLeft1 responsive6000LeftRight signUpLastName'>
                                <label>{A12Y_CONST.LABEL.LAST_NAME}</label>
                                <input
                                    {...register('lastName', { required: A12Y_CONST.ERROR_MESSAGE.SIGNUP_LAST_NAME_REQUIRED , pattern:{
                                        value:/^.{1,}$/,
                                        //value:/^[^\s]+(\s+[^\s]+)*.{3,}$/,
                                        message:A12Y_CONST.ERROR_MESSAGE.SIGNUP_LAST_NAME_INVALID
                                    }})}
                                    placeholder='Last Name'
                                    className={errors.lastName ? 'inputColum errorInputBorderRed': 'inputColum'}
                                    type='text'
                                    id='userLastNameAbonelaw'
                                    onChange={(e) => handleChangeLastName(e.target.value)}
                                    value={lastName}
                                   // autoComplete="none"
                                    onFocus={()=>{
                                        setError("lastName", {
                                            type: "manual",
                                            message: "",
                                        });
                                    }}
                                />
                                <div className='errorRelativeRow'>{errors.lastName && <p className='errorMessage'>{errors.lastName.message}</p>}</div>
                            </div>
                        </div>
                        <div className='fullWidth marginBottomInputCol responsive6000LeftRight signUpPasswordResponsive'>
                            <label>{A12Y_CONST.LABEL.EMAIL}</label>
                            <input
                                {...register('username', { required: A12Y_CONST.ERROR_MESSAGE.EMAIL_REQUIRED , pattern:{
                                    //value:/^(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?\.)+[a-z0-9]{1,61}$/,
                                    //eslint-disable-next-line
                                    value:/^\w+([\+.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/,
                                    message:A12Y_CONST.ERROR_MESSAGE.SIGNUP_USERNAME_INVALID
                                }})}
                                placeholder='Email'
                                className={errors.username ? 'inputColum errorInputBorderRed': 'inputColum'}
                                type='text'
                                id='userEmailAbonelaw'
                                readOnly={Object.keys(props.inviteUserInfo).length > 0}
                                onChange={(e) => handleUserName(e.target.value)}
                                //autoCompleteType="none"
                                value={userName}
                                onFocus={()=>{
                                    setError("username", {
                                        type: "manual",
                                        message: "",
                                    });
                                }}
                            />
                            <div className='errorRelativeRow'>{errors.username && <p className='errorMessage'>{errors.username.message}</p>}</div>
                        </div>
                        {/* register an input */}
                        <div className={'fullWidth positionRelative'}>
                            <label>{A12Y_CONST.LABEL.PASSWORD}</label>
                            <input
                                {...register('password', { required: A12Y_CONST.ERROR_MESSAGE.SIGNUP_PASSWORD_REQUIRED,
                                    pattern:{
                                        value:/^(?=.*[0-9])(?=.*[!=@#$%^&*])[a-zA-Z0-9!=@#$%^&*]{8,}$/,
                                        message:A12Y_CONST.ERROR_MESSAGE.SIGNUP_PASSWORD_INVALID
                                    }
                                })}
                                id='userPasswordAbonelaw'
                               // autoCompleteType="none"
                                placeholder='Password'
                                    className={ errors.password !== undefined && errors.password?.message !== '' ? 'inputColum errorInputBorderRed PaddingPasswordIcon': 'inputColum PaddingPasswordIcon'}
                                onChange={handleChangePassword}
                                type={passwordShown ? "text" : "password"}
                                value={password}
                                onKeyDown={e => handeBlankSpace(e)}
                                onFocus={()=>{
                                    setError("password", {
                                        type: "manual",
                                        message: "",
                                    });
                                }}
                            />
                            <div  id='passwordShowHideAbonelaw' className="passwordTextShow" onClick={togglePasswordVisiblity}>
                                {
                                    passwordShown ?
                                        <svg xmlns="http://www.w3.org/2000/svg" width="20" height="14" viewBox="0 0 20 14" fill="none">
                                            <path d="M13 7C13 8.657 11.657 10 10 10C8.343 10 7 8.657 7 7C7 5.343 8.343 4 10 4C11.657 4 13 5.343 13 7Z" fill="#2D6CB2"/>
                                            <path d="M19.8938 6.55299C17.7358 2.23599 13.9028 0 9.99976 0C6.09676 0 2.26375 2.23599 0.10575 6.55299C-0.03525 6.83399 -0.03525 7.16601 0.10575 7.44701C2.26375 11.764 6.09676 14 9.99976 14C13.9028 14 17.7358 11.764 19.8938 7.44701C20.0348 7.16601 20.0348 6.83399 19.8938 6.55299ZM9.99976 12C7.03076 12 3.99777 10.379 2.12977 7C3.99777 3.621 7.03076 2 9.99976 2C12.9688 2 16.0018 3.621 17.8698 7C16.0018 10.379 12.9688 12 9.99976 12Z" fill="#2D6CB2"/>
                                        </svg>
                                        :
                                        <svg width="20" height="18" viewBox="0 0 20 18" fill="none" xmlns="http://www.w3.org/2000/svg">
                                            <path d="M2.70676 0.29325C2.31676 -0.09775 1.68276 -0.09775 1.29276 0.29325C0.901762 0.68325 0.901762 1.31725 1.29276 1.70725L3.71677 4.13125C2.28577 5.20725 1.03875 6.68524 0.10575 8.55324C-0.03525 8.83424 -0.03525 9.16626 0.10575 9.44726C2.26375 13.7643 6.09676 16.0002 9.99976 16.0002C11.5548 16.0002 13.0988 15.6453 14.5308 14.9453L17.2928 17.7073C17.6828 18.0983 18.3168 18.0983 18.7068 17.7073C19.0978 17.3173 19.0978 16.6832 18.7068 16.2932L2.70676 0.29325ZM13.0138 13.4282C12.0338 13.8112 11.0128 14.0003 9.99976 14.0003C7.03076 14.0003 3.99777 12.3793 2.12977 9.00025C2.94677 7.52125 3.98777 6.37925 5.14777 5.56325L7.29175 7.70725C7.10475 8.09825 6.99976 8.53725 6.99976 9.00025C6.99976 10.6573 8.34276 12.0003 9.99976 12.0003C10.4628 12.0003 10.9018 11.8952 11.2928 11.7082L13.0138 13.4282Z" fill="#2D6CB2"></path>
                                            <path d="M16.5519 10.895C17.0349 10.34 17.4779 9.709 17.8699 9C16.0019 5.621 12.9689 4 9.99991 4C9.88791 4 9.77591 4.002 9.66391 4.007L7.87891 2.22301C8.57691 2.07501 9.28791 2 9.99991 2C13.9029 2 17.7359 4.23599 19.8939 8.55299C20.0349 8.83399 20.0349 9.16601 19.8939 9.44701C19.3499 10.535 18.6999 11.491 17.9689 12.312L16.5519 10.895Z" fill="#2D6CB2"></path>
                                        </svg>
                                }

                            </div>
                            {passwordErrorHide || !passwordConditionBox? <div className='errorRelativeRow'> {errors.password && <p className='errorMessage'>{errors.password.message}</p>}</div> : null}
                        </div>
                        {passwordConditionBox ?
                            <div className="passwordMatchBox fullWidth">
                                <ul>
                                    {
                                        passwordCondition.map((item, index) => {
                                            return(
                                                <li key={index} className='passowrdListOfCondition' style={index === passwordCondition.length - 1 ? { width: '100%' } : {}}>
                                                    <span className='rightIocn'><Check className={item.status ? 'checkIconActive':'checkIcon'}/></span>
                                                    <span className='passowrdListOfConditionText'>{item.name}</span>
                                                </li>
                                            )
                                        })
                                    }
                                </ul>
                            </div>
                            :
                            null
                        }
                        <div className='fullWidth termAndPrivacyPolicyRowSignUp'>
                            <div className='termAndPrivacyPolicyText'>
                                {A12Y_CONST.MESSAGE.SINGUP_BY_CLICING}
                                <a className='signUpTextLinkColor' target='blank' href={A12Y_CONST.TEXT.TERMS_OF_SERVICE_URL}>{A12Y_CONST.LABEL.TERMS_OF_SERVICE}</a> and<br/> <a className='signUpTextLinkColor' target='blank' href={A12Y_CONST.TEXT.PRIVACY_POLICY_URL}>{A12Y_CONST.LABEL.SINGUP_PRIVACY_POLICY}</a>.
                            </div>
                        </div>


                        <div className={isUserInvite?'fullWidth texAlingCener':'fullWidth marginTop15 texAlingCener'}>
                          <div className='loaderSpinner8radius'>
                          {loading ?
                                <Loading/>
                                :
                                null
                            }
                            <input id='signUpAbonelawButton' className={isBtnDisabled ? "buttonDisable" :'button'} disabled={isBtnDisabled}  type="button" onClick={handleSubmit(onSubmit)} value={props.signUpText.title === A12Y_CONST.LABEL.ITS_FREE_ACCOUNT ? !loading ? A12Y_CONST.BUTTON_TEXT.CREATE_FREE_ACCOUNT :A12Y_CONST.BUTTON_TEXT.CREATING_FREE_ACCOUNT : !loading ? A12Y_CONST.BUTTON_TEXT.SIGNUP_SIGNUP : A12Y_CONST.BUTTON_TEXT.SIGNUP_SIGNINGUP}/>
                          </div>
                        </div>
                        {!props.userEmail ?
                            <>
                        <div className="fullWidth paddingleft16 paddingRight16">
                                <div className="fullWidth orButton positionRelative texAlingCener">
                                    <span>Or</span>
                                </div>
                            </div>
                            <div onClick={handleGoogleLogin} id='GoogleSignUpButtonAbonelaw'
                                 className="fullWidth googleSignUpButton paddingleft16 paddingRight16 marginTop10">
                                <div className="fullWidth googleLoginBUtton">
                                    <svg width="26" height="26" viewBox="0 0 26 26" fill="none"
                                         xmlns="http://www.w3.org/2000/svg">
                                        <path
                                            d="M25.6902 13.2434C25.6902 12.1781 25.6037 11.4008 25.4167 10.5947H13.2531V15.4025H20.3928C20.2489 16.5974 19.4716 18.3967 17.7442 19.6058L17.72 19.7668L21.5659 22.7462L21.8324 22.7727C24.2794 20.5127 25.6902 17.1875 25.6902 13.2434"
                                            fill="#4285F4"/>
                                        <path
                                            d="M13.253 25.9106C16.7509 25.9106 19.6874 24.759 21.8323 22.7726L17.7442 19.6056C16.6502 20.3686 15.1819 20.9012 13.253 20.9012C9.82709 20.9012 6.91936 18.6412 5.88283 15.5176L5.7309 15.5305L1.73186 18.6254L1.67957 18.7708C3.80998 23.0028 8.18602 25.9106 13.253 25.9106Z"
                                            fill="#34A853"/>
                                        <path
                                            d="M5.88284 15.5175C5.60934 14.7114 5.45106 13.8477 5.45106 12.9552C5.45106 12.0627 5.60934 11.1991 5.86845 10.393L5.8612 10.2213L1.81205 7.07666L1.67957 7.13968C0.801523 8.89587 0.297699 10.868 0.297699 12.9552C0.297699 15.0425 0.801523 17.0145 1.67957 18.7707L5.88284 15.5175"
                                            fill="#FBBC05"/>
                                        <path
                                            d="M13.253 5.00937C15.6857 5.00937 17.3267 6.06018 18.2624 6.93833L21.9187 3.36839C19.6732 1.28115 16.7509 0 13.253 0C8.18602 0 3.80998 2.90773 1.67957 7.13978L5.86844 10.3931C6.91936 7.26938 9.82709 5.00937 13.253 5.00937"
                                            fill="#EB4335"/>
                                    </svg>
                                    <span>{props.signUpText.title === A12Y_CONST.LABEL.ITS_FREE_ACCOUNT ? A12Y_CONST.BUTTON_TEXT.CREATE_FREE_ACCOUNT_VIA_GOOGLE : A12Y_CONST.BUTTON_TEXT.JOIN_VIA_GOOGLE}</span>
                                </div>
                            </div>
                        </>
                        :
                        null
                        }
                        </form>
                        <>
                        {!props.userEmail ?
                            <div id='alreadyHasAccountAbonelaw' className='joinNowText fullWidth'>
                                {A12Y_CONST.LABEL.SINGUP_ALREADY_HAVE} <span
                                onClick={goToSignInScreen}>{A12Y_CONST.LABEL.SINGUP_SINGIN}</span>
                            </div>
                            :
                            null
                        }
                        </>
                </div>


        </div>

    );
}


export default withRouter(connect(null,null) (SignUpFormAbonelawComponent));
